import React from "react";
import { Card as MuiCard, CardContent as MuiCardContent } from "@mui/material";

const Card = ({
    children,
    padding = 2,
    sx
}) => {
    return (
        <MuiCard sx={{
            border: "1px solid #E6DEB8",
            boxShadow: "0px 0px 20px rgba(0, 0, 0, 0.1)",
        }}>
            <MuiCardContent sx={{ "&.MuiCardContent-root": { padding: padding }, ...sx }}>
                {children}
            </MuiCardContent>
        </MuiCard >
    );
};

export default Card;
